<template>
    <a-card :bordered="false" class="card-area">
  
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <!-- 搜索区域 -->
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item :label="$t('system.user.roleNameFormItem')" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
                <a-input :placeholder="$t('system.user.placeholderRoleNameFormItem')" v-model="queryParam.roleName"></a-input>
              </a-form-item>
            </a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery">{{ $t('antd.table.search') }}</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">{{ $t('antd.table.reset') }}</a-button>
              </a-col>
            </span>
          </a-row>
        </a-form>
      </div>
  
      <!-- 操作按钮区域 -->
      <div class="table-operator"  style="margin-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('antd.table.add') }}</a-button>
        <!-- <a-button type="primary" icon="download" @click="handleExportXls('角色信息')">导出</a-button> -->
        <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload> -->
  
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('antd.table.delect') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            {{ $t('antd.table.batchOperation') }} <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('antd.table.selected') }}&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>&nbsp;{{ $t('antd.table.item') }}&nbsp;&nbsp;
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('antd.table.clear') }}</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">

          <span slot="tags" slot-scope="tags">
            <a-tag
                :color="tags == '1' ? 'geekblue' :  'volcano'"
            >
                {{ tags == '1' ? $t('system.character.enable') :  $t('system.character.disabled') }}
            </a-tag>
          </span>

          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">{{ $t('antd.table.edit') }}</a>
            <a-divider type="vertical" />
  
  
            <a-dropdown>
              <a class="ant-dropdown-link">
                {{ $t('antd.table.more') }} <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handlePerssion(record)">{{ $t('antd.table.accredit') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm :title="$t('antd.table.delectVerify')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('antd.table.delect') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
  
  
        </a-table>
        
         <!-- 表单区域 -->
        <Charactercreater ref="modalForm" @ok="modalFormOk"></Charactercreater>
        
        
        <a-drawer
            :title="drawerTitle"
            placement="right"
            :closable="true"
            :width="600"
            :bodyStyle="{ height: 'calc(100% - 66px)' }"
            :visible="drawerVisible"
            :after-visible-change="afterVisibleChange"
            @close="onClose"
            >
            <DepartAuthModal style="height:100%" ref="modalUserRole"></DepartAuthModal>
         </a-drawer>
      </div>
      <!-- table区域-end -->


     
      
      <!-- <user-role-modal ref="modalUserRole"></user-role-modal> -->
    </a-card>
  </template>
  
  <script>
    import Charactercreater from './modules/Charactercreater'
    import DepartAuthModal from './modules/DepartAuthModal'
    //import UserRoleModal from './modules/UserRoleModal'
    import { TableListMixin } from '@/situation/mixins/tableListMixin'
  
    
    export default {
      name: "RoleList",
      mixins:[TableListMixin],
      components: {
        Charactercreater,
        DepartAuthModal
      },
      data () {
        return {
          drawerTitle:"抽屉标题",
          drawerVisible: false,
          description: '角色管理页面',
          // 查询条件
          queryParam: {roleName:'',},
          // 表头
          columns: [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.$t('system.user.roleNameFormItem'),
              align:"center",
              dataIndex: 'roleName'
            },
            {
              title: this.$t('system.character.roleGroupingFormItem'),
              align:"center",
              dataIndex: 'roleGroup'
            },
            {
              title: this.$t('antd.table.remark'),
              align:"center",
              dataIndex: 'description'
            },
            {
              title: this.$t('system.character.roleEnabled'),
              dataIndex: 'enabled',
              align:"center",
              scopedSlots: { customRender: 'tags' },
            },
            {
              title: this.$t('antd.table.createTime'),
              dataIndex: 'createTime',
              align:"center",
            },
            {
              title: this.$t('antd.table.batch'),
              dataIndex: 'action',
              align:"center",
              scopedSlots: { customRender: 'action' },
            }
          ],
          url: {
            selectData: "/ndt/role/page",
            deleteData:"/ndt/role/delete"
          },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },
      methods: {
        onClose(){
          this.$refs.modalUserRole.close();
          this.drawerVisible = false
        },
        handlePerssion: function(role){
          this.drawerVisible = true;
          this.drawerTitle = this.$t("system.character.menuPermissions") + "：" + role.roleName
          
          this.$nextTick(() => {
            this.$refs.modalUserRole.show(role.id);
          })
        },
        afterVisibleChange(val) {
            console.log('visible', val);
        },
        onChangeDate(date, dateString) {
          console.log(date, dateString);
        },
      }
    }
  </script>
  <style lang="less" scoped>
    @import '~@/assets/less/common.less';
  </style>